import { IS_CLIENT } from "@/common/api";
import { IAppStatus } from "@/common/interface";
import {
  initAllAppStatus,
  SoftStatus,
  callClient,
  pauseDownloadApp,
  openApp,
  OpenType,
  execute,
  openDetailInDetail,
  switchToGame,
  callApp,
} from "@q/softCore";

const defaultFn = () => void 0;

export const getDownloadHandler = (status: SoftStatus) => {
  switch (status) {
    case SoftStatus.notDownloading:
    case SoftStatus.downloadPaused:
    case SoftStatus.downloadCanceled:
    case SoftStatus.downloadFailed:
    case SoftStatus.supportExpressInstall:
    case SoftStatus.supportExpressUpdate:
    case SoftStatus.supportPureInstall:
    case SoftStatus.finishDownloadAndAboutToInstall:
    case SoftStatus.installCanceled:
    case SoftStatus.installFailed:
    case SoftStatus.couldUpdate:
    case SoftStatus.supportPureUpdate:
      return (softId: number, position?: string) =>
        startDownloadApp(softId, 1, position);
    case SoftStatus.downloadWithProgress:
    case SoftStatus.downloadWithExpressAndProgress:
      return (softId: number) => pauseDownloadApp(softId);
    case SoftStatus.installSucceed:
      return (softId: number) => openApp(softId);
    default:
      return defaultFn;
  }
};

export const INSTALL_PROMISE = (soft_id: Array<number>) => {
  if (!IS_CLIENT) {
    return Promise.resolve(true);
  }
  return initAllAppStatus(soft_id).then(
    (data: IAppStatus) => {
      const installStatus = [
        SoftStatus.installSucceed,
        SoftStatus.couldUpdate,
        SoftStatus.supportExpressUpdate,
        SoftStatus.supportPureUpdate,
        SoftStatus.installedButCannotOpen,
      ];

      return Object.keys(data).some((key) =>
        installStatus.includes(data[Number(key)]),
      );
    },
    () => {
      return true;
    },
  );
};

// 开始下载软件
export function startDownloadApp(
  softId: number,
  autoInstall = 1,
  position?: string,
): Promise<any> {
  if (position) {
    return callClient("startDownloadApp", softId, autoInstall, position);
  }
  return callClient("startDownloadApp", softId, autoInstall);
}
export function openDetailInHome(
  softId: number,
  track: string,
  position?: string,
  soft_from?: string,
): Promise<any> {
  return callClient("showApp", softId, track, `${position}|${soft_from}`);
}

// 覆盖softcore
// 游戏管家相关的 type 不进行操作
export const getOpenHandler = (type: OpenType) => {
  switch (type) {
    case OpenType.openWithBrowser:
      return (url: string) => window.open(url);
    case OpenType.openWithClient:
      return (url: string) => {
        window.location.href = url;
      };
    case OpenType.openDetailInDetail:
      return (softId: number) => openDetailInDetail(softId);
    case OpenType.openDetailInHome:
      return (
        softId: number,
        track = `打开-${softId}`,
        position?: string,
        soft_from?: string,
      ) => {
        if (position && soft_from) {
          return openDetailInHome(softId, track, position, soft_from);
        }
        return openDetailInHome(softId, track);
      };

    case OpenType.download:
      return (status: SoftStatus) => getDownloadHandler(status);
    case OpenType.goToGameTab:
      return () => switchToGame();
    case OpenType.execCmdWithClient:
      return (cmd: string) => execute(cmd);
    case OpenType.openAppWithCmd:
      return (param: string) => callApp(param);
    default:
      return defaultFn;
  }
};

export const getFullUrl = (
  url: string,
  position?: string,
  soft_from?: string,
) => {
  const newUrl = new URL(url);
  const urlSearchParams = newUrl.searchParams;
  if (!urlSearchParams.has("position") && position) {
    urlSearchParams.append("position", position);
  }
  if (!urlSearchParams.has("soft_from") && soft_from) {
    urlSearchParams.append("soft_from", soft_from);
  }
  return newUrl.toString();
};
